// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { BaseResponseListFeishuDepFoundResponse } from '../../types';

/**
 * 获取飞书根部门信息
 *
 * @export
 * @tags feishu-dep-controller
 * @link [GET] /feishuDeps/root
 */
export function getFeishuDepsRoot(): Promise<BaseResponseListFeishuDepFoundResponse>;
export function getFeishuDepsRoot(
    options: ApiOptions<never, never>
): Promise<BaseResponseListFeishuDepFoundResponse>;
export function getFeishuDepsRoot(
    options?: ApiOptions<never, never>
): Promise<BaseResponseListFeishuDepFoundResponse> {
    return request<never, never, never>('/feishuDeps/root', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getFeishuDepsRoot',
    });
}

export const meta = [{ tags: ['feishu-dep-controller'], path: '/feishuDeps/root', method: 'get' }];
